import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { catchError, from, map, of } from 'rxjs';
import { importLibrary, setOptions } from '@googlemaps/js-api-loader';
import { environment } from '@szte-griffin/environment';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable()
export class GoogleLoaderService {
  mapLoaded = toSignal(this.loadMapApi(), { initialValue: false });

  private loadMapApi(): Observable<boolean> {
    setOptions({
      key: environment.googleMapsApiKey,
      v: 'weekly',
    });
    return from(Promise.all([importLibrary('maps'), importLibrary('marker')])).pipe(
      map(() => true),
      catchError(() => of(false)),
    );
  }
}
